export default __webpack_public_path__ + "static/media/background.c58d6597.jpg";